import { useRef, useState } from 'react'
import { getLastTooltipTime, updateLastTooltipTime } from './tooltipTiming'

const NO_DELAY_TIME = 2000 // msec (If less than this time has passed hovering over elements that trigger tooltips, use no delay to show the tooltip)

export default function useTooltipDelay(delay: number = (window.Checksub?.tooltipDelay ?? window.EditorSources.tooltipDelay)) {
  const [showTooltip, setShowTooltip] = useState(false)
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  const triggerShowTooltip = () => {
    if (timeoutRef.current) {
      return
    }

    const now = Date.now()
    const lastShown = getLastTooltipTime()
    const usedDelay = lastShown && now - lastShown < NO_DELAY_TIME ? 0 : delay

    timeoutRef.current = setTimeout(() => {
      setShowTooltip(true)
      updateLastTooltipTime()
    }, usedDelay)
  }

  const cancelTooltip = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = null
    }
    setShowTooltip(false)
  }

  return {
    showTooltip,
    setShowTooltip,
    triggerShowTooltip,
    cancelTooltip,
  }
}
